<template>
  <div>
    <div class="relative flex items-center border-b">
      <FontAwesomeIcon
        v-if="loading"
        :icon="faSpinnerThird"
        class="pointer-events-none absolute left-4 top-4 size-4 animate-spin text-gray-400"
        aria-hidden="true"
      />
      <FontAwesomeIcon
        v-else
        :icon="faMagnifyingGlass"
        class="pointer-events-none absolute left-4 top-4 size-4 text-gray-400"
        aria-hidden="true"
      />
      <input
        v-model="query"
        type="text"
        class="flex h-12 w-full border-0 bg-transparent py-3 pl-10 pr-2 text-sm outline-hidden placeholder:text-gray-400 focus:border-0 focus:outline-hidden focus:ring-0 disabled:cursor-not-allowed disabled:opacity-50"
        placeholder="Search..."
        autocomplete="off"
        autocorrect="off"
        spellcheck="false"
        @keydown.down.prevent="activeItemNext"
        @keydown.up.prevent="activeItemPrevious"
        @keydown.enter.prevent="handleEnterKey"
        @keydown.tab.prevent="handleTabKey"
      >
      <Keyboard
        class="mr-4 cursor-pointer"
        @click="closeSearchPalette"
      >
        Esc
      </Keyboard>
    </div>
    <ul
      class="max-h-screen divide-y divide-gray-200 overflow-y-auto"
    >
      <template
        v-for="group in searchResults.results"
        :key="group.name"
      >
        <li
          class="p-2"
        >
          <div class="flex justify-between px-4 py-2 text-xs">
            <SpectreHeading
              as="h3"
              size="sm"
              class="uppercase"
            >
              {{ group.name }}
            </SpectreHeading>
            <SpectreTextLink
              :href="group.viewAllUrl"
              :trailing-icon="faArrowUpRightFromSquare"
            >
              View all
            </SpectreTextLink>
          </div>
          <Collapse
            speed="fast"
            :collapsed="group.searchResults.length === 0 || query === ''"
          >
            <ul
              class="text-sm text-gray-700"
            >
              <li
                v-for="item in group.searchResults"
                :key="item.id"
                :class="['relative flex cursor-pointer select-none items-center rounded-md px-4 py-2', isActiveItem(item) ? 'border border-gray-400 bg-gray-50 text-primary-700' : 'border border-transparent']"
                @click="view(item.viewUrl)"
                @mousemove="setActiveItem(item)"
              >
                <div class="flex-auto truncate font-medium">
                  {{ item.name }}
                </div>
                <div
                  v-if="isActiveItem(item)"
                  class="absolute right-4 flex items-center space-x-3"
                >
                  <div
                    class="ml-3 flex items-center space-x-1 text-xs font-semibold text-gray-700 hover:text-primary-700"
                    @click.stop="view(item.viewUrl)"
                  >
                    <Keyboard>Enter</Keyboard>
                    <span>to View</span>
                  </div>
                  <template v-if="item.shadowUrl">
                    <div class="h-9 w-px bg-gray-400" />
                    <div
                      class="flex items-center space-x-1 text-xs font-semibold text-gray-700 hover:text-primary-700"
                      @click.stop="shadow(item.shadowUrl)"
                    >
                      <Keyboard>Tab</Keyboard>
                      <span>to Shadow</span>
                    </div>
                  </template>
                </div>
              </li>
            </ul>
          </Collapse>
        </li>
      </template>
    </ul>
  </div>
</template>
<script setup lang="ts">
import { faArrowUpRightFromSquare, faSpinnerThird } from '@awesome.me/kit-644ec404bf/icons/classic/solid';
import { faMagnifyingGlass } from '@awesome.me/kit-644ec404bf/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import useGlobalSearch from '@/Composables/useGlobalSearch';
import Keyboard from '@/Components/Shared/Keyboard.vue';
import Collapse from '@/Components/Shared/Collapse.vue';
import { SpectreHeading, SpectreTextLink } from '@agentsoftware/spectre-ui';

const {
  closeSearchPalette,
  loading,
  searchResults,
  query,
  setActiveItem,
  isActiveItem,
  view,
  shadow,
  handleEnterKey,
  handleTabKey,
  activeItemNext,
  activeItemPrevious,
} = useGlobalSearch();

</script>
